import { Loading, Table } from '@octano/global-ui';
import { Col, Row } from 'reactstrap';
import { useRiskObservationsStudentListLoader } from '../loaders/StudentRiskObservationsStudentListLoader';
import { useFormContext } from 'react-hook-form';
import { useObservationsColumns } from '../hooks/useObservationsColumns';

export function StudentRiskObservationsList() {
  const { result, loading, query, updateQuery } =
    useRiskObservationsStudentListLoader();
  const methods = useFormContext();
  const columns = useObservationsColumns();
  const selectedSchool = methods.watch('school');
  const data = result?.success ? result.data : undefined;

  return (
    <>
      {selectedSchool && (
        <Row xs={12} className="mt-4">
          {loading ? (
            <Col xs={12}>
              <Loading insideCard textBody="Cargando ..." />
            </Col>
          ) : (
            <Col xs={12}>
              <Table
                columns={columns}
                data={data?.data ?? []}
                pagination={{
                  itemsPerPage: query.items_per_page,
                  currentPage: query.page,
                  totalItems: data?.total ?? 0,
                  totalPages: data?.total_pages ?? 0,
                  onChangePage: (nextPage) => {
                    updateQuery({
                      ...query,
                      page: nextPage,
                    });
                  },
                }}
              />
            </Col>
          )}
        </Row>
      )}
    </>
  );
}
